import { message } from "antd";
import { API_URL, PDF_URL, BASE_URL } from "./Constant";
import { store } from '../app/store.jsx';
import { clearStore } from "../app/slice/authSlice.js";
import axiosInstance from "./axiosInstance.js";
import { logoutUser } from "../app/slice/thunk/authActions.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const CryptoJS = require("crypto-js");
const secret_key = "asdfghjklpoiuytrewszxcvbnm"

// utils page me handlePdfDownload function update karna
export const handlePdfDownload = (
  link,
  errorMessageShown,
  setErrorMessageShown
) => {
  if (link) {
    window.open(`${link}`, "_blank");
    // Reset error message state
    !!setErrorMessageShown && setErrorMessageShown(false);
  } else {
    // Show error message only if it hasn't been shown already
    if (!errorMessageShown) {
      message.error("Document does not exist.");
      setErrorMessageShown(true);

      // Automatically reset error message state after 5 seconds (5000 milliseconds)
      setTimeout(() => {
        setErrorMessageShown(false);
      }, 5000);
    }
  }
};

const convertToPem = (keyBuffer) => {
  const base64 = window.btoa(
    String.fromCharCode(...new Uint8Array(keyBuffer))
  );
  const formatted = base64.match(/.{1,64}/g).join('\n');
  return formatted;
};

export async function generateKeyPair() {
  const keyPair = await window.crypto.subtle.generateKey(
    {
      name: "RSA-OAEP",
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: "SHA-256",
    },
    true,
    ["encrypt", "decrypt"]
  );

  const publicKey = await window.crypto.subtle.exportKey("spki", keyPair.publicKey);
  const privateKey = await window.crypto.subtle.exportKey("pkcs8", keyPair.privateKey);
  const publicKeyPem = convertToPem(publicKey);
  const privateKeyPem = convertToPem(privateKey);


  return { publicKeyPem, privateKeyPem };
}

export function decryptData(encryptedText) {
  try {
    // Only decrypt if it's encrypted (you can set a prefix like ENC_ or check type)
    if (typeof encryptedText !== "string") return encryptedText;

    const bytes = CryptoJS.AES.decrypt(encryptedText, secret_key);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    // Validate before JSON parse
    if (!decrypted) throw new Error("Empty decrypted string");

    return JSON.parse(decrypted);
  } catch (err) {
    console.error("Decryption failed:", err);
    return encryptedText; // fallback to raw
  }
}

// utils/roleUtils.js
export function hasRole(userRole, allowedRoles) {
  if (!userRole) return false;
  return allowedRoles
    .map(r => r.trim().toLowerCase())
    .includes(userRole.trim().toLowerCase());
}


export function encryptData(decryptedText) {
  try {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(decryptedText), secret_key).toString();
    return ciphertext;
  } catch (err) {
    console.error("encryption failed:", err);
    return decryptedText;
  }
}

export function capitalizeAndRemoveUnderscores(sentence) {
  return sentence
    ?.replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word && word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function convertToCamelCase(text) {
  // Remove spaces and convert to lowercase
  const camelCaseText = text.replace(/\s+/g, "").toLowerCase();

  // Capitalize the first letter
  return camelCaseText.charAt(0).toUpperCase() + camelCaseText.slice(1);
}


export const limitWords = (text, limit) => {
  if (text?.length > limit*2) {
    return text?.slice(0, limit*2) + "...";
  }
  return text;
};

export const formatDateAndTime = (modifiedAt) => {
  const options = {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = new Date(modifiedAt).toLocaleString("en-US", options);

  return formattedDate;
};
export function toTitleCase(str) {
  return str.replace(/\b\w+/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
export const findMaxIndex = (customField) => {
  let maxIndex = 0;

  for (const key in customField) {
    if (key.startsWith("field") || key.startsWith("value")) {
      const index = parseInt(key.slice(-1), 10);
      if (!isNaN(index) && index > maxIndex) {
        maxIndex = index;
      }
    }
  }

  return maxIndex;
};
export const parseDuration = (duration) => {
  // Use a regular expression to extract the numbers for years, months, and days
  const regex = /(\d+)\s*Years?\s*(\d+)\s*Months?\s*(\d+)\s*Days?/;

  return duration.match(regex);

}

export const normalizeTeamProductivityData = (data) => {
  const isRoleBased = data?.[0]?.role !== undefined;

  if (!isRoleBased) {
    // When data already has department_name (initial load)
    return data.map(item => ({
      department_name: item.department_name,
      days: parseFloat(item.days)
    }));
  }

  // When data is role-based (after searching)
  const grouped = {
    Legal: 0,
    Business: 0,
    "Counter Party": 0,
  };

  const others = {};

  data.forEach(item => {
    const role = item.role?.toLowerCase() || "";
    const days = parseFloat(item.days) || 0;

    if (role.includes("agreement controller")) {
      grouped["Legal"] += days;
    } else if (role.includes("business")) {
      grouped["Business"] += days;
    } else if (role.includes("counter")) {
      grouped["Counter Party"] += days;
    } else {
      const deptName = role
        .replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word

      if (others[deptName]) {
        others[deptName] += days;
      } else {
        others[deptName] = days;
      }
    }
  });

  // Merge all together
  return [
    ...Object.entries(grouped).map(([dept, val]) => ({
      department_name: dept,
      days: parseFloat(val.toFixed(2))
    })),
    ...Object.entries(others).map(([dept, val]) => ({
      department_name: dept,
      days: parseFloat(val.toFixed(2))
    }))
  ];
};


///  Download FIle

export const downloadFile = async (url, name = "download_file", notIncludesUrl) => {
  try {
    // if (process.env.NODE_ENV === "development" && !notIncludesUrl) {
    //   url = BASE_URL + url;
    // }
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute("download", name);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error triggering download:", error);
  }
}

export const downloadChartAsPDF = async (elementId, filename = "chart.pdf") => {
  const input = document.getElementById(elementId);
  console.log("input", input);
  if (!input) return;

  const canvas = await html2canvas(input, {
    scale: 2, // higher quality
    useCORS: true,
    backgroundColor: "#ffffff"
  });

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgProps = pdf.getImageProperties(imgData);
  const ratio = imgProps.width / imgProps.height;
  const pdfWidth = pageWidth;
  const pdfHeight = pageWidth / ratio;

  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  pdf.save(filename);
};

// PNG
export const downloadChartAsPNG = async (elementId, filename = "chart.png") => {
  const input = document.getElementById(elementId);
  if (!input) return;

  const canvas = await html2canvas(input, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  });

  const link = document.createElement("a");
  link.href = canvas.toDataURL("image/png");
  link.download = filename;
  link.click();
};

// SVG (fake via canvas to SVG conversion — true SVG not possible via canvas)
export const downloadChartAsSVG = async (elementId, filename = "chart.svg") => {
  const input = document.getElementById(elementId);
  if (!input) return;

  const canvas = await html2canvas(input, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  });

  const dataURL = canvas.toDataURL("image/png");
  const svgContent = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${canvas.width}" height="${canvas.height}">
      <image href="${dataURL}" width="100%" height="100%" />
    </svg>
  `;
  const blob = new Blob([svgContent], { type: "image/svg+xml;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};

export const downloadCSV = (data, filename = "data.csv") => {
  if (!data || !data.length) return;

  const headers = Object.keys(data[0]);
  const csvRows = [headers.join(",")];

  data.forEach(row => {
    const values = headers.map(header => {
      const val = row[header];
      return typeof val === "string" ? `"${val}"` : val;
    });
    csvRows.push(values.join(","));
  });

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};


///  Check base currency
export const isEqualCurrency = (currency) => {
  if (!currency) return false;

  console.log("currency", currency);

  // Extract the part after '+' (e.g. "XCD+Antigua and Barbuda" → "Antigua and Barbuda")
  currency = currency.includes('+') ? currency.split('+')[1] : currency;

  const userCurrency = store.getState().auth?.userInfo?.currency;
  if (!userCurrency) return false;

  const currArray = userCurrency.split(' ');
  const curr = currArray?.slice(0, -1)?.join(' ');

  console.log({ curr, currency });

  return currency?.toLowerCase() === curr?.toLowerCase();
};

// utils/getIconColor.js
export const getIconColor = (darkMode, status, activeColor) => {
  if (status === "cancelled") return "gray";
  return darkMode ? activeColor : activeColor;
};



// control  decimal  value
export const ctrlDcmalVal = (value, num = 2) => {

  if (!value) {
    return value
  } else if (typeof value === "string") {
    if (!value?.trim()) {
      return value
    }
    value = parseFloat(value, 10)
  }
  if (value % 1 === 0) {
    return value
  }
  return value.toFixed(num);
}

// Function to validate email format

export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

// CONVERT BASE 64 

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const convertIntoFormData = (values) => {
  const formData = new FormData();
  Object.entries(values).forEach(([key, value]) => {
    if (value != undefined) {
      formData.append(key, value);
    }
  });
  return formData
}


export const performLogout = () => {
  store.dispatch(logoutUser());
  const channel = new BroadcastChannel('auth-channel');
  channel.postMessage({ action: 'logout' });
  // window.location.href = '/auth/login'; 
};

export const decryptByLink = async (link) => {
  if (!link) {
    message.error('There is no file to download');
    return false;
  }
  const payload = {
    agreement_url: process.env.NODE_ENV === "development" ? BASE_URL + link : link
  }
  try {
    const res = await axiosInstance.post(`/decrypt-file/`, payload);
    if (res?.data?.decrypted_file_url) {
      await downloadFile(res.data.decrypted_file_url, "decrypted_file.pdf");
      message.success('Download completed')
    }
  } catch (error) {
    message.error('Could not download')
  }

}

export const sentFirebaseToken = async (token) => {
  try {
    await axiosInstance.post(`/save-firebase-token/`, { firebase_token: token });
  } catch (error) {
    console.log(error)
  }

}



